<script>
    import VSelect from '@alfsnd/vue-bootstrap-select'

    export default {
        mixins:[VSelect],
        props:{
            id:{ type:String, default:'Search Select'},
            labelTitle:{ type: String, default: 'Select an Option' }
        },
        methods:{
            onSelect(option, index) {
                if (option && !option[this.disabledProp]) {
                    this.selectedValue = option;
                    this.typeAheadPointer = index;
                    this.hideDropdown();
                    this.$emit("input", option, this.id, option[this.valueProp], index);
                } else if (option === null) {
                    this.selectedValue = null;
                }
            },
        },
        computed:{
            filteredOptions() {
                if (this.searchable && this.searchValue.length > 0) {
                    const saved_search_value = this.searchValue
                    setTimeout(() => 
                        saved_search_value === this.searchValue
                        ?   this.$emit('get_more_options', saved_search_value, this.id)
                        :   null
                    , 250)
                    return this.options.filter(item => {
                        if (typeof item === "object") {
                            return (
                                item[this.textProp]
                                .toLowerCase()
                                .indexOf(this.searchValue.toLowerCase()) !== -1
                            );
                        } else {
                            return (
                                item.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
                            )
                        }
                    })
                    .filter((_, i) => i < 100)
                }
                return this.options.filter((_, i) => i < 100)
            }
        }
    }
</script>

<style>

    .v-select{
        margin: 0px;
        min-width: 220px;
        height: 38px;
    }

    .v-select-toggle{
        background: white!important;
        height: 38px!important;
        border: 1px solid #ced4da!important;
        border-radius: 0.25rem!important;
        font-size: 1rem!important;
        color: #495057!important;
        font-family: inherit!important;
    }

    .arrow-down{
        border-top: 0.4em solid!important;
    }

    .v-dropdown-item{
        font-size: 1rem!important;
        font-family: inherit!important;
        padding-left: 14px!important;
        padding-right: 14px!important;
        padding-top: 0px!important;
        padding-bottom: 3px!important;
        padding-top: 3px!important;
    }

    .v-dropdown-container {
        overflow: auto;
        height: 350px;
    }

</style>
